import * as React from 'react';
import { FunctionComponent } from 'react';
import GITextIntl from '@components/common/app-components/GIText/GITextIntl';

const TobaccoExemptHeader: FunctionComponent = () => {

    return (
        <div className={'header__additional-info__wrapper'}>
            <h4 id={'header__additional-info'} className={'heading'}>
                <GITextIntl messageId='indportal.tobacco.header.additionalInfoNeeded' id='additional-info__header'/>
            </h4>
        </div>
    );
};

export default TobaccoExemptHeader;
